export function formatHexCode(hex: string): string {
    if (hex.startsWith('#')) {
      return hex;
    }
    return `#${hex}`;
  }